/*
 * File: product-list-item.component.ts                                        *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 12th January 2022 13:27:37                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { Product } from '@nousmedis/cc-types';
import { ProductService } from '../../../services/product.service';
import { TooltipOptions } from 'primeng/api';

@Component({
  selector: 'app-product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss'],
})
export class ProductListItemComponent implements OnInit, OnDestroy {
  @Input() item: any;

  selected: boolean = false;
  showDetails: boolean = false;

  imSelected: Subscription = new Subscription();
  showTooltip$: Subscription = new Subscription();
  imageSource: string = '';
  elevation = '';

  showTooltip: boolean = false;
  myTooltipPosition: string = 'left';

  baseUri = '';
  defaultImage = '';

  tooltipOptions: TooltipOptions = {
    showDelay: 100,
    hideDelay: 100,
    tooltipZIndex: 'z-index: 1000',
  };

  constructor (private productService: ProductService) { }
  ngOnDestroy(): void {
    this.imSelected.unsubscribe();
    this.showTooltip$.unsubscribe();
  }

  ngOnInit(): void {
    // this.getImage();
    this.productService.isShowProductDetails().subscribe((show: boolean) => {
      this.showTooltip = show;
    });

    this.imSelected = this.productService.viewDetails.subscribe((data: Product) => {
      if (data.id != this.item.id) this.selected = false;
      else this.selected = true;
    });

    this.showTooltip$ = this.productService.showProductDetailsWindow$.subscribe(
      (show: boolean) => {
        this.showTooltip = show;
      }
    );
  }

  sendProductToDetailView() {
    this.productService.productDetails$.next(this.item);
  }

  select(item: any) {

    this.productService.selectedProduct(item);
  }

  async getImage() {
    const img = await fetch(this.item.img, { mode: 'no-cors' });
  }

  addElevation() {
    this.elevation = '';
  }

  removeElevation() {
    this.elevation = '';
  }

  dragItem(event: DragEvent) {
    if (!event) return;

    const dragPreview = event.target as HTMLElement;

    //añadir la funcion para editar el preview del drag
    this.setPreviewStyle(event, dragPreview);

    this.productService.dragProduct({
      idCell: null,
      item: this.item,
      idPage: null,
    });
  }
  dragEnd(event: DragEvent) {
    console.log('!OnDragEnd funciona');
    const element = event.target as HTMLElement;
    element.classList.remove('dragging');
  }

  setPreviewStyle(event: DragEvent, dragPreview: HTMLElement) {
    this.productService.setPreviewStyle(event, dragPreview, this.item);
  }
}
